<template>
  <div style="width: 100%; height: 100%; position: relative" >
    <div :style="{width:'100%', height:'100%'}" :id="id"></div>
    <div v-show="isNull" class="nostr">No Data</div>
  </div>
</template>

<script>
  import echarts from 'echarts'

  export default {
    name: 'ChartBar',
    props: {
      id: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        default: ''
      },
      keyName: {
        type: Array,
        default () {
          return []
        }
      },
      keyCount:{
        type: Array,
        default () {
          return []
        }
      },
      title: {
        type: String,
        default: ''
      },
      unit: {
        type: String,
        default: '10 thousand CNY'
      },

      barColor: {
        type: String,
        default: '#56D457'
      },
      barBorderColor: {
        type: String,
        default: '#0DBF14'
      },

      dataZoomFlag: {
        type: Boolean,
        default: true
      },
      option: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        isNull:false,
        dataZoomConfig: [
          {
            type: 'inside',
            start: 0,
            end: 40
          },
          {
            height: 17,
            type: 'slider',
            borderColor: '#fff',
            backgroundColor: '#F4F4F4',
            fillerColor: '#E0E2F5',
            dataBackground: {
              lineStyle: {
                // 线的颜色
                color: '#e0e2f5'
                // width: 3,
                // opacity: 1
              },
              areaStyle: {
                color: '#E0E2F5'
              }
            },
            handleIcon: 'path://M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z'
          }
        ]
      }
    },
    methods: {},
    watch: {
      keyCount: {
        handler (newVal) {
          if (newVal.length) {
            // 判断是不是所有值都是空
          
            let arr = this.keyCount
            arr = arr.find(ele => { return ele != null})
            if(arr == undefined){
              this.isNull = true
            }else{
              this.isNull = false
            }

            const chart = echarts.init(document.getElementById(this.id))
            const option = {
              tooltip: {
              backgroundColor: 'rgba(255,255,255,0)',
              formatter: (params) => {
               //  如果没值 显示 暂无数据
                let arr = ''
                for(let i = 0;i<this.keyName.length;i++){
                  if(this.keyCount == null || this.keyCount == undefined){
                   arr = arr + `<p style="margin: 0; color: #000; font-size: 12px;">
                                 ${this.keyName[i].name}:
                                 <span style="color: #409EFF">
                                   No Data
                                 </span> 
                              </p>`
                  }else{
                   arr = arr + `<p style="margin: 0; color: #000; font-size: 12px;">
                                 ${this.keyName[i].name}:
                                 <span style="color: #409EFF">
                                    ${this.keyCount[i]}
                                 </span> 
                              </p>`                  }
                          
                  }
                  return `
                  <div style="position: relative;">
                      <div style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">Number:</p>
                          
                              ${arr}
                         
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                  <div style="margin-top: 5px; position: relative; width: 100%; height: 18px;">
                    <div style="position: absolute; left: 50%; top: 5px; margin-left: -9px; width: 18px; height: 18px; background: #fff; border: 3px solid #FAA800; border-radius: 50%"></div>
                  </div>
                `
               }
              },
              //提示层
              legend: {
                data: ['name1']
              },
              radar: {
                name: {
                  textStyle: {
                    color: '#000', //字体颜色
                    // backgroundColor: '#999', //背景色
                    // borderRadius: 3, //圆角
                    // padding: [3, 5] //padding
                  },
                formatter: function(value) {
                  return (value.length > 10 ? (value.slice(0,10)+"...") : value );
                  },
                },
                // center: ['50%', '50%'],
                // radius: '60%',
                // startAngle: 270,

                indicator: this.keyName,
                color:'#000',
              },
              series: [{
                type: 'radar',
                data: [{
                  value: this.keyCount,
                  name: "Number",
                  // label:{normal: {
                  //   formatter: function(params) {
                  //       
                  //   }
                  // }}
                }]
              }]
            }
            chart.setOption(option)
          }else{
            this.isNull = true
          }
        }
      }
    },
  mounted () {
    window.addEventListener('resize', () => {
      const chart = echarts.init(document.getElementById(this.id))
      chart.resize()
    })
  }
  }
</script>

<style scoped>
  .unit {
    position: absolute;
    top: 10px;
    right: 35px;
    font-size: 12px;
    color: #717982;
  }
  .nostr{
    position: absolute;
    top: 0;
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    height: 100%;
    width: 100%;
  }
</style>
